module.exports = __webpack_public_path__ + "img/01e1285.png";